export const industries = [
  {
    title: "Banking",
    route: "banking",
  },
  {
    title: "Real Estate",
    route: "real-estate",
  },
  {
    title: "Insurance",
    route: "insurance",
  },
  {
    title: "Telecommunications",
    route: "telecoms",
  },
  {
    title: "Agriculture",
    route: "agriculture",
  },
  {
    title: "Health",
    route: "health",
  },
  {
    title: "Media",
    route: "media",
  },

  {
    title: "Software",
    route: "software",
  },
  {
    title: "Transportation",
    route: "transportation",
  },
  {
    title: "Warehousing",
    route: "warehousing",
  },
  {
    title: "Retail",
    route: "retail",
  },
  {
    title: "Utilities",
    route: "utilities",
  },
  {
    title: "Manufacturing",
    route: "manufacturing",
  },
  {
    title: "Wholesale Trade",
    route: "wholesale",
  },
  {
    title: "Professional Services",
    route: "professional",
  },
];
